import { generateClient } from 'aws-amplify/api';
import Vue from 'vue';
import * as qlqueries from '../graphql/queries';

const client = generateClient();
const graphqlOperation = (query, variables) => ({ query, variables });

const state = {
    name: 'AuditLogs',
    logs: {},
    loading: false,
};

const getters = {
};

const mutations = {

    setLogs: (state, payload) => {
        Vue.set(state, 'logs', payload);
    },

    setLoading: (state, payload) => {
        Vue.set(state, 'loading', payload);
    },

    appendLogs: (state, payload) => {
        const currentItems = state.logs?.items || [];
        const nextItems = payload?.items || [];
        const mergedById = new Map();

        currentItems.forEach((item) => {
            if (item?.id) mergedById.set(item.id, item);
        });
        nextItems.forEach((item) => {
            if (item?.id) mergedById.set(item.id, item);
        });

        Vue.set(state, 'logs', {
            ...(state.logs || {}),
            ...(payload || {}),
            items: Array.from(mergedById.values()),
        });
    },
};

const actions = {
    async listAuditLogs({ commit }, variables = { limit: 250, append: false }) {
        commit('setLoading', true);
        try {
            const { append, ...graphqlVariables } = variables || {};
            const result = await client.graphql(
                graphqlOperation(qlqueries.listAuditLogs, graphqlVariables),
            );
            const { data } = result;
            if (append) {
                commit('appendLogs', data.listAuditLogs);
            } else {
                commit('setLogs', data.listAuditLogs);
            }

            commit('setLoading', false);
            return data.listAuditLogs;
        } catch (error) {
            commit('setLoading', false);
            console.error(error);
            return { error: true, message: error.errors };
        }
    },
    async filterAuditLogs({ commit }, payload) {
        commit('setLoading', true);
        try {
            const filter = payload?.filter || payload;
            const limit = payload?.limit || 250;
            const nextToken = payload?.nextToken;
            const append = !!payload?.append;
            const result = await client.graphql(
                graphqlOperation(qlqueries.listAuditLogs,
                    {
                        filter,
                        limit,
                        nextToken,
                    }),
            );
            const { data } = result;
            if (append) {
                commit('appendLogs', data.listAuditLogs);
            } else {
                commit('setLogs', data.listAuditLogs);
            }

            commit('setLoading', false);
            return data.listAuditLogs;
        } catch (error) {
            commit('setLoading', false);
            console.error(error);
            return { error: true, message: error.errors };
        }
    },
    async fetchAllAuditLogs({ commit }, payload = {}) {
        commit('setLoading', true);
        try {
            const filter = payload?.filter || null;
            const limit = payload?.limit || 250;
            let nextToken = null;
            let isFirstPage = true;
            let finalLogs = { items: [], nextToken: null };

            // When a createdAt date range is present, use the GSI for efficient querying.
            // Move createdAt from filter to a key condition so DynamoDB uses the index directly.
            const useGsi = filter?.createdAt?.between?.length === 2;
            let gsiCreatedAt = null;
            let remainingFilter = null;

            if (useGsi) {
                gsiCreatedAt = { between: filter.createdAt.between };
                const { createdAt: _removed, ...rest } = filter;
                remainingFilter = Object.keys(rest).length > 0 ? rest : null;
            }

            do {
                let query;
                let queryVariables;

                if (useGsi) {
                    query = qlqueries.auditLogsByCreatedAt;
                    queryVariables = {
                        logType: 'AuditLog',
                        createdAt: gsiCreatedAt,
                        sortDirection: 'DESC',
                        limit,
                        nextToken,
                        ...(remainingFilter ? { filter: remainingFilter } : {}),
                    };
                } else {
                    query = qlqueries.listAuditLogs;
                    queryVariables = {
                        limit,
                        nextToken,
                        ...(filter ? { filter } : {}),
                    };
                }

                const result = await client.graphql(graphqlOperation(query, queryVariables));
                const resultKey = useGsi ? 'auditLogsByCreatedAt' : 'listAuditLogs';
                const page = result?.data?.[resultKey] || { items: [], nextToken: null };
                finalLogs = page;

                if (isFirstPage) {
                    commit('setLogs', page);
                    isFirstPage = false;
                } else {
                    commit('appendLogs', page);
                }

                nextToken = page?.nextToken || null;
            } while (nextToken);

            if (isFirstPage) {
                finalLogs = { items: [], nextToken: null };
                commit('setLogs', finalLogs);
            }

            commit('setLoading', false);
            return finalLogs;
        } catch (error) {
            commit('setLoading', false);
            console.error(error);
            return { error: true, message: error.errors };
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
